import { render } from "./DietCategoryIcon.vue?vue&type=template&id=75b8b27c"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__